import * as elementComponents from './element/index';
export default { elementComponents };
